import { useState, useEffect } from 'react'

interface UseCopyToClipboardReturn {
    copyIcon: string;
    contentCopied: boolean;
    handleCopy: (content: string) => Promise<void>;
}

/** @param resetAfterMilliseconds how long `contentCopied` stays true (the check icon shows) before it resets */
export const useCopyToClipboard = (resetAfterMilliseconds = 2000): UseCopyToClipboardReturn => {
    const [contentCopied, setContentCopied] = useState(false)
    const [copyIcon, setCopyIcon] = useState('copy')

    useEffect(() => {
        if (contentCopied) {
            setCopyIcon('checkmark')
            const timer = setTimeout(() => {
                setCopyIcon('copy')
                setContentCopied(false)
            }, resetAfterMilliseconds)
            return () => clearTimeout(timer)
        }
    }, [contentCopied, resetAfterMilliseconds])

    const handleCopy = async (content: string) => {
        if (content) {
            try {
                await navigator.clipboard.writeText(content)
                setContentCopied(true)
            } catch (err) {
                console.warn('Failed to copy to clipboard:', err)
            }
        }
    }

    return { copyIcon, contentCopied, handleCopy }
}
